import Link from "next/link";
import { cn } from "@/lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Avatar } from "@radix-ui/react-avatar";
import { AvatarFallback, AvatarImage } from "../ui/avatar";
import { safeJsonParse } from "@/lib/safeJsonParse";
import Editor from "./read-only-editor";
import moment from "moment";

export const OrganizationBadge = ({ organization, className }: any) => {
  return organization ? (
    <Popover>
      <PopoverTrigger
        className="flex items-center gap-1 group"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-row items-center gap-2 text-sm font-medium capitalize transition-opacity group-hover:opacity-100 opacity-60">
          <Avatar className="w-5 h-5 overflow-hidden rounded-full shadow-sm">
            <AvatarImage
              src={
                process.env.BASE_FILE_BUCKET_URL +
                "/storage/" +
                safeJsonParse(organization.image)?.filename
              }
              alt={organization}
            />
            <AvatarFallback className="w-5 h-5 text-xs capitalize border rounded-md bg-slate-400/50">
              {organization.name[0]}
            </AvatarFallback>
          </Avatar>

          <>{organization.name}</>
        </div>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="flex flex-col p-0 rounded-xl bg-background/80 backdrop-blur "
      >
        <div className="flex flex-row p-1">
          <Link
            href={"/collectives/" + organization.id}
            className={cn(
              "p-2 flex items-center gap-1 group hover:bg-slate-400/10 w-full rounded-lg",
              className,
            )}
          >
            <div className="flex flex-row gap-2">
              <Avatar className="w-10 h-10 overflow-hidden rounded-md">
                <AvatarImage
                  src={
                    process.env.BASE_FILE_BUCKET_URL +
                    "/storage/" +
                    safeJsonParse(organization.image)?.filename
                  }
                  alt={organization}
                />
                <AvatarFallback className="w-10 h-10 overflow-hidden capitalize rounded-md">
                  {organization.name[0]}
                </AvatarFallback>
              </Avatar>
              <div>
                <div className="text-sm capitalize">{organization.name}</div>
                <div className="text-xs text-muted-foreground">
                  Since {moment(organization.createdAt).fromNow()}
                </div>
              </div>
            </div>
          </Link>
        </div>
        <div className="max-w-full p-3 overflow-x-hidden overflow-y-scroll max-h-96">
          <Editor value={safeJsonParse(organization.description)} />
        </div>
      </PopoverContent>
    </Popover>
  ) : null;
};
